import { Component, OnInit } from '@angular/core';
import { MessageService, LazyLoadEvent } from 'primeng/api';
import { FoodService, ConfigService } from 'app/services';
import { Utils } from 'app/utils';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
    selector: 'food-modifiers',
    templateUrl: './food-modifiers.component.html',
    styleUrls: ['./food-modifiers.component.scss'],
    providers: [MessageService]
})
export class FoodModifiersComponent implements OnInit {
    public modifiers: Array<any> = [];

    public cols: any[] = [
        { field: 'Id', header: 'Id', width: '90px' },
        { field: 'CreatedAt', header: 'Created', width: '200px' },
        { field: 'Name', header: 'Name', width: '200px' },
        { field: 'RestaurantName', header: 'Restaurant', width: '200px' },
        { field: 'ImageUrl', header: 'Image', width: '200px', disableSort: true }
    ];

    // Grid settings
    public rowsPerPage: number = 50;
    public rowsPerPageOptions: Array<number> = [50, 100, 500, 1000];
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;

    public filter: {
        searchName: string;
    } = { searchName: '' };

    private searchTimer: number = 0;

    public editModifierId: number = 0;
    public showEditModifierPopup: boolean = false;

    public restaurants: Array<any> = [];

    constructor(
        private messageService: MessageService,
        private foodService: FoodService,
        public configService: ConfigService) {
        this.handleEditModifierPopupHide = this.handleEditModifierPopupHide.bind(this);
        this.handleEditModifierPopupSave = this.handleEditModifierPopupSave.bind(this);
    }

    ngOnInit(): void {
        this.getRestaurants();
    }

    private getRestaurants(): void {
        this.foodService.getRestaurantsForCombo(null, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.restaurants = data.Items;
            });
    }

    handleLazyLoad(event: TableLazyLoadEvent): void {
        //event.first = First row offset
        //event.rows = Number of rows per page
        //event.sortField = Field name to sort in single sort mode
        //event.sortOrder = Sort order as number, 1 for asc and -1 for dec in single sort mode
        //multiSortMeta: An array of SortMeta objects used in multiple columns sorting. Each SortMeta has field and order properties.
        //filters: Filters object having field as key and filter value, filter matchMode as value
        //globalFilter: Value of the global filter if available

        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        this.getModifiers(skip);
    }

    private getModifiers(skip: number): void {
        const dto = {
            SearchName: this.filter.searchName,
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder
        };

        this.foodService.getAdminModifiers(dto, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.first = skip;
                this.totalRecords = data.TotalRecords;

                this.modifiers = data.ModifierList;

                this.modifiers.forEach(x => {
                    x.CreatedAt = Utils.utcToLocaleDateString(x.CreatedAt);
                });
            });
    }

    public handleFilterChange(): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getModifiers(0);
            this.searchTimer = 0;
        }, 1500);
    }

    public handleCreateModifierClick(): void {
        this.editModifierId = 0;
        this.showEditModifierPopup = true;
    }

    public handleEditModifierClick(modifier: any): void {
        this.editModifierId = modifier.Id;
        this.showEditModifierPopup = true;
    }

    public handleEditModifierPopupHide(): void {
        this.showEditModifierPopup = false;
    }

    public handleEditModifierPopupSave(): void {
        this.handleFilterChange();
        this.showEditModifierPopup = false;

        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully saved' });
    }
}
